'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

DigestSpeedMonitorDirective=function(_BaseControllerBacked){_inherits(DigestSpeedMonitorDirective,_BaseControllerBacked);function DigestSpeedMonitorDirective(){_classCallCheck(this,DigestSpeedMonitorDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(DigestSpeedMonitorDirective,[{key:'template',get:function()
{return`
        <div id="digest-speed-monitor" ng-show='controller.enabled' title="Current Digest Speed, FPS, and Watcher Count"></div>`}},{key:'optionalObjectBindings',get:function()

{
return['enabled'];
}},{key:'controller',get:function()

{return DigestSpeedMonitorDirectiveController}},{key:'$inject',get:function()

{return['$scope','$interval']}}]);return DigestSpeedMonitorDirective}(BaseControllerBackedDirective);


let stopMonitoring;let
DigestSpeedMonitorDirectiveController=function(){
function DigestSpeedMonitorDirectiveController($scope,$element,$interval){var _this2=this;_classCallCheck(this,DigestSpeedMonitorDirectiveController);
this._$scope=$scope;
this._$element=$element;
this._$interval=$interval;

$scope.$evalAsync(function(){
_this2.enabled=_.exists(_this2.enabled)?_this2.enabled:!0;
});

this._currentSpeedClass='';

if(_.exists(stopMonitoring)){
clearInterval(stopMonitoring);
}

stopMonitoring=setInterval(function(){
if(!_this2.enabled){
return;
}

const digestSpeed=AngularHelpers.getDigestSpeed({logResult:!1});
const numWatchers=AngularHelpers.getWatchers()._total;
const watcherDiff=_this2._numWatchers?numWatchers-_this2._numWatchers:0;

_this2._watcherDiff=watcherDiff;
_this2._numWatchers=numWatchers;

let speedClass;
if(digestSpeed+watcherDiff<1){
speedClass='great';
}else if(digestSpeed+watcherDiff<10){
speedClass='good';
}else if(digestSpeed+watcherDiff<20){
speedClass='okay';
}else if(digestSpeed+watcherDiff<50){
speedClass='warn';
}else if(digestSpeed+watcherDiff<150){
speedClass='bad';
}else{
speedClass='terrible';
}

_this2._update(digestSpeed,speedClass,numWatchers,watcherDiff);
},5000);

$scope.$on('$destroy',function(){
clearInterval(stopMonitoring);
});
}DigestSpeedMonitorDirectiveController.prototype.

_update=function _update(digestSpeed,speedClass,numWatchers,watcherDiff){
this._monitorElement.className=speedClass;
this._monitorElement.innerText=`${digestSpeed.toFixed(3)} ms ${(1000/digestSpeed).toFixed(0)} fps ${numWatchers}${watcherDiff!==0?'('+(watcherDiff>0?'+':'')+watcherDiff+')':''}w`;
};_createClass(DigestSpeedMonitorDirectiveController,[{key:'_monitorElement',get:function()

{
return this.__monitorElement||(this.__monitorElement=this._$element.find('#digest-speed-monitor')[0]);
}}]);return DigestSpeedMonitorDirectiveController}();



module.exports=DigestSpeedMonitorDirective;
//# sourceMappingURL=digestSpeedMonitorDirective.js.map
